import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import {
  Box,
  Button,
  Alert,
  Snackbar,
  RadioGroup,
  FormControl,
  Radio,
  FormControlLabel,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI403_1 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    occupationalHealthDetails: { status: true, remarks: "" },
    legalRequirements: { status: true, remarks: "" },
    riskIdentification: { status: true, remarks: "" },
    coverageProvided: { status: true, remarks: "" },
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleRadioChange = (event, section) => {
    const statusValue = event.target.value === "yes"; // Convert to boolean
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        status: statusValue,
      },
    }));
  };

  const handleRadioChange1 = (event) =>
    handleRadioChange(event, "legalRequirements");
  const handleRadioChange2 = (event) =>
    handleRadioChange(event, "riskIdentification");
  const handleRadioChange3 = (event) =>
    handleRadioChange(event, "coverageProvided");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        const data = response.data.data.GRI400?.healthAndSafety || {};
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);

        setFormData({
          occupationalHealthDetails: {
            remarks: data.occupationalHealthDetails?.remarks || "",
            status: Boolean(data.occupationalHealthDetails?.status), // Ensure Boolean
          },
          riskIdentification: {
            remarks: data.riskIdentification?.remarks || "",
            status: Boolean(data.riskIdentification?.status),
          },
          legalRequirements: {
            remarks: data.legalRequirements?.remarks || "",
            status: Boolean(data.legalRequirements?.status),
          },
          coverageProvided: {
            remarks: data.coverageProvided?.remarks || "",
            status: Boolean(data.coverageProvided?.status),
          },
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleNestedInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));

    // Remove error for the specific field
    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate required fields in the formData
    if (formData.occupationalHealthDetails.status) {
      // Validate `days` field
      if (!formData.occupationalHealthDetails.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    if (formData.legalRequirements.status) {
      // Validate `days` field
      if (!formData.legalRequirements.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    if (formData.riskIdentification.status) {
      // Validate `days` field
      if (!formData.riskIdentification.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    if (formData.coverageProvided.status) {
      // Validate `days` field
      if (!formData.coverageProvided.remarks) {
        newErrors.remarks = "This field is required";
        formIsValid = false;
      }
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return;

      const payload = {
        type: "GRI400",
        healthAndSafety: {
          occupationalHealthDetails: {
            remarks: formData.occupationalHealthDetails.remarks,
            status: Boolean(formData.occupationalHealthDetails.status), // Ensure Boolean
          },
          legalRequirements: {
            remarks: formData.legalRequirements.remarks,
            status: Boolean(formData.legalRequirements.status),
          },
          riskIdentification: {
            remarks: formData.riskIdentification.remarks,
            status: Boolean(formData.riskIdentification.status),
          },
          coverageProvided: {
            remarks: formData.coverageProvided.remarks,
            status: Boolean(formData.coverageProvided.status),
          },
        },
        submitted403_1: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/403-2/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/403-2/${id}`);
    }
  };


  const renderContent = ({hide}) => (
     <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      {!hide && <p className={styles.section_heading} style={{ marginBottom: hide ? "-1rem" : "0" }}>
        403 : Occupational Health and Safety
      </p>}
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-2rem" : "0" }}>
        403-1 : Occupational health and safety management system
      </p>
      <SectionHeading
        text="a. Has an occupational health and safety management system been established within the organization?"
        sx={{ marginTop: "2rem", marginBottom: hide ? "-2rem" : "-1rem" }}
      />
      <Box>
        <FormControl sx={{ margin: "1rem" }}>
          <RadioGroup
            row
            value={formData.occupationalHealthDetails.status ? "yes" : "no"}
            onChange={(e) => handleRadioChange(e, "occupationalHealthDetails")}
            disabled={disabled}
          >
            <FormControlLabel
              value="yes"
              control={<Radio disabled={disabled} />}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio disabled={disabled} />}
              label="No"
            />
          </RadioGroup>
        </FormControl>
        {formData.occupationalHealthDetails.status && (
          <CustomTextField
            value={formData.occupationalHealthDetails.remarks}
            onChange={(e) =>
              handleNestedInputChange(
                "occupationalHealthDetails",
                "remarks",
                e.target.value
              )
            }
            error={errors.remarks}
            helperText={errors.remarks}
            disabled={disabled}
          />
        )}

        <Box sx={{ marginLeft: "1rem" }}>
          <SectionHeading
            text="i. Was the implementation of system driven by legal requirements? If so, please provide a list of the relevant legal requirements."
            sx={{ marginBottom: "-1rem" }}
          />
          <FormControl sx={{ margin: "1rem" }}>
            <RadioGroup
              row
              value={formData.legalRequirements.status ? "yes" : "no"}
              onChange={(e) => handleRadioChange1(e, "legalRequirements")}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {formData.legalRequirements.status && (
            <CustomTextField
              value={formData.legalRequirements.remarks}
              onChange={(e) =>
                handleNestedInputChange(
                  "legalRequirements",
                  "remarks",
                  e.target.value
                )
              }
              error={errors.remarks}
              helperText={errors.remarks}
              disabled={disabled}
            />
          )}

          <SectionHeading
            text="ii. Was the implementation of system based on recognized risk management and/or management system standards/guidelines? If yes, please provide a list of the standards/guidelines utilized."
            sx={{ marginBottom: "-1rem" }}
          />
          <FormControl sx={{ margin: "1rem" }}>
            <RadioGroup
              row
              value={formData.riskIdentification.status ? "yes" : "no"}
              onChange={(e) => handleRadioChange2(e, "riskIdentification")}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {formData.riskIdentification.status && (
            <CustomTextField
              value={formData.riskIdentification.remarks}
              onChange={(e) =>
                handleNestedInputChange(
                  "riskIdentification",
                  "remarks",
                  e.target.value
                )
              }
              error={errors.remarks}
              helperText={errors.remarks}
              disabled={disabled}
            />
          )}
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading
          text="b. Could you provide a comprehensive description of the extent of coverage provided by the occupational health and safety management system concerning workers, activities, and workplaces? Additionally, please explain whether any workers, activities, or workplaces are not covered by the system and, if so, provide the rationale behind their exclusion."
          sx={{ marginBottom: "-1rem" }}
        />
        <FormControl sx={{ margin: "1rem" }}>
          <RadioGroup
            row
            value={formData.coverageProvided.status ? "yes" : "no"}
            onChange={(e) => handleRadioChange3(e, "coverageProvided")}
            disabled={disabled}
          >
            <FormControlLabel
              value="yes"
              control={<Radio disabled={disabled} />}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio disabled={disabled} />}
              label="No"
            />
          </RadioGroup>
        </FormControl>

        {/* Conditionally Rendered Fields */}
        {formData.coverageProvided.status && (
          <Box>
            <CustomTextField
              value={formData.coverageProvided.remarks}
              onChange={(e) =>
                handleNestedInputChange(
                  "coverageProvided",
                  "remarks",
                  e.target.value
                )
              }
              error={errors.remarks}
              helperText={errors.remarks}
              disabled={disabled}
            />
          </Box>
        )}

        {/* Submit Button */}
       

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI403_1;
